import axios from "axios";

/**
 * Базовый URL API.
 *
 * Приоритет:
 *   1) REACT_APP_API_BASE_URL (если задан в front-dev/.env) — явное переопределение;
 *   2) для локальной разработки (localhost/127.0.0.1) — тестовый стенд mis2;
 *   3) иначе — тот же origin ("/api/"), т.е. прод-сборка ходит на свой домен.
 *
 * Раньше localhost жёстко ходил на https://mis.code378.ru/api/ — а это ещё
 * старый PHP-бэкенд (без settings/profile), из-за чего новые фичи не работали.
 */
export function getApiBaseUrl() {
    const override = process.env.REACT_APP_API_BASE_URL;
    if (override) {
        return override.endsWith("/") ? override : `${override}/`;
    }

    const hostname =
        typeof window !== "undefined" && window?.location?.hostname
            ? window.location.hostname
            : "";

    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

    return isLocalhost
        ? "https://mis2.code378.ru/api/"
        : "/api/";
}

export function buildFileUrl(fileId, inline = true) {
    const id = Number(fileId);
    if (!id) {
        return "";
    }

    const inlineParam = inline ? "&inline=1" : "";
    return `${getApiBaseUrl()}file.php?id=${id}${inlineParam}`;
}

async function fetchBlobByRequest(requestPayload, emptyIdMessage) {
    const formData = new FormData();
    formData.append("request", JSON.stringify(requestPayload));

    const response = await axios.post(getApiBaseUrl(), formData, {
        withCredentials: true,
        responseType: "blob",
        validateStatus: () => true,
    });

    const contentType = String(response?.headers?.["content-type"] ?? "");
    const blob = response?.data;

    if (!(blob instanceof Blob)) {
        throw new Error("Не удалось загрузить файл");
    }

    if (response.status >= 400 || contentType.includes("application/json")) {
        let message = "Не удалось загрузить файл";
        try {
            const text = await blob.text();
            const parsed = JSON.parse(text);
            if (parsed?.error) {
                message = parsed.error;
            } else if (parsed?.request?.message) {
                message = parsed.request.message;
            }
        } catch {
            // keep default message
        }
        throw new Error(message || emptyIdMessage);
    }

    return blob;
}

export async function fetchFileBlob(fileId, inline = true) {
    const id = Number(fileId);
    if (!id) {
        throw new Error("Не указан id файла");
    }

    return fetchBlobByRequest(
        {
            module: "file",
            block: "download",
            id,
            inline: inline ? 1 : 0,
        },
        "Не указан id файла",
    );
}

/** Скачивание/превью согласия строго из template_document.path */
export async function fetchAgreementBlob(documentId, inline = true) {
    const id = Number(documentId);
    if (!id) {
        throw new Error("Не указан id документа");
    }

    return fetchBlobByRequest(
        {
            module: "patient",
            block: "agreements",
            action: "download",
            id,
            inline: inline ? 1 : 0,
        },
        "Не указан id документа",
    );
}

async function GetData(request, file, options = {}) {
    const apiUrl = getApiBaseUrl();


    const request__json = JSON.stringify(request);

    const formData = new FormData();

    formData.append("request", request__json);

    if (file) {
        // file может быть одиночным File, массивом File или FileList.
        // ВАЖНО: Array.from(File) возвращает [] — File не итерируемый,
        // поэтому одиночный файл нужно оборачивать в массив вручную.
        const filesArray = (
            file instanceof File
                ? [file]
                : Array.from(file || [])
        ).filter((fileItem) => fileItem instanceof File);

        if (filesArray.length === 1) {
            formData.append("files", filesArray[0], filesArray[0].name);
        } else {
            filesArray.forEach((fileItem) => {
                formData.append("files[]", fileItem, fileItem.name);
            });
        }
    }

    const axiosConfig = {
        withCredentials: true, // отправка cookie (сессия PHP) при cross-origin
    };
    if (options.timeout != null) {
        axiosConfig.timeout = options.timeout;
    }

    return axios
        .post(apiUrl, formData, axiosConfig)
        .then((response) => {
            // Обработка полученных данных
            const payload = response?.data;
            return payload?.request ?? payload;
        })
        .catch((error) => {
            return error;
        });
}

export default GetData;
